import { render, staticRenderFns } from "./Images.vue?vue&type=template&id=72c8dc9d&scoped=true&"
import script from "./Images.vue?vue&type=script&lang=js&"
export * from "./Images.vue?vue&type=script&lang=js&"
import style0 from "./Images.vue?vue&type=style&index=0&id=72c8dc9d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72c8dc9d",
  null
  
)

export default component.exports